import client from '@/shared/apis/client'
import { type SoapContentItem } from '@/shared/types/yakurekiSoap'

import {
  type TracingReportItem,
  type TracingReportRule,
} from '../types/tracingReport'

const BASE_URL = '/api/tracing-report'

export const getTracingReportRules = async (): Promise<TracingReportRule[]> => {
  const response = await client.get<TracingReportRule[]>(`${BASE_URL}/rules/`)
  return response.data
}

export const createTracingReportRule = async (
  drugGroupId: string
): Promise<TracingReportRule> => {
  const response = await client.post<TracingReportRule>(`${BASE_URL}/rules/`, {
    drug_group: drugGroupId,
  })
  return response.data
}

export const deleteTracingReportRule = async (id: string): Promise<void> => {
  await client.delete(`${BASE_URL}/rules/${id}/`)
}

export const getTracingReportItems = async (
  yakurekiId: string
): Promise<TracingReportItem[]> => {
  const response = await client.get<TracingReportItem[]>(
    `${BASE_URL}/events/${yakurekiId}/items/`
  )
  return response.data
}

// 手動作成・再生成 (⋯メニュー)。item が無ければ手動起点 item を作って生成、
// あれば全 item を再生成する。同期実行で生成後の item 一覧が返る。
export const generateTracingReport = async (
  yakurekiId: string
): Promise<TracingReportItem[]> => {
  const response = await client.post<TracingReportItem[]>(
    `${BASE_URL}/events/${yakurekiId}/generate/`
  )
  return response.data
}

export const patchTracingReportItem = async (
  itemId: string,
  reportJson: SoapContentItem[]
): Promise<TracingReportItem> => {
  const response = await client.patch<TracingReportItem>(
    `${BASE_URL}/items/${itemId}/`,
    { report_json: reportJson }
  )
  return response.data
}
